import { TIME_CONSTANTS as m } from "./constants.js";
import { sortSystemsByConstraints as c } from "./ordering.js";
class p {
  accumulator = 0;
  setup = /* @__PURE__ */ new WeakSet();
  systemGroupCache = /* @__PURE__ */ new Map();
  lastSystemsSize = 0;
  getAccumulator() {
    return this.accumulator;
  }
  step(s, e = m.DEFAULT_DELTA) {
    const r = m.FIXED_TIMESTEP, t = s.time;
    for (t.deltaTime = e, t.elapsed += e, this.accumulator += e, this.runSystemGroup(s, "setup"); this.accumulator >= r; )
      t.deltaTime = r, this.runSystemGroup(s, "fixed"), this.accumulator -= r;
    t.deltaTime = e, this.runSystemGroup(s, "simulation"), this.runSystemGroup(s, "draw");
  }
  runSystemGroup(s, e) {
    const r = this.getSystemsByGroup(s, e);
    for (const t of r)
      this.setup.has(t) || (t.setup?.(s), this.setup.add(t)), t.update?.(s);
  }
  getSystemsByGroup(s, e) {
    s.systems.size !== this.lastSystemsSize && (this.systemGroupCache.clear(), this.lastSystemsSize = s.systems.size);
    const r = e;
    if (this.systemGroupCache.has(r))
      return this.systemGroupCache.get(r);
    const t = Array.from(s.systems), i = t.filter(
      (o) => (o.group ?? "simulation") === e
    ), u = c(i, e, t);
    return this.systemGroupCache.set(r, u), u;
  }
}
export {
  p as Scheduler
};
//# sourceMappingURL=scheduler.js.map
